import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  AppBar,
  Button,
  DialogContent,
  Typography,
  Toolbar,
  IconButton,
  Icon,
  Dialog,
  Box,
  Select,
  MenuItem,
  TextField,
  DialogTitle,
  Tooltip,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.min.css";
import moment from "moment";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { toast } from "react-toastify";
import OAuthService from "src/app/auth/services/oAuthService";
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

const handleDateFormat = (props) => {
  return props.value && moment(props.value).format("DD-MM-YYYY - HH:mm");
};

export default function PendingAbReportSummary(props) {
  const baseUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const gridRef = useRef(null);
  const [selectedPriority, setSelectedPriority] = useState("");
  const [remarksText, setRemarksText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const { open, currentOrder: originalOrder, handleClose } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [currentOrder, setCurrentOrder] = useState([]);

  useEffect(() => {
    if (!originalOrder) return;

    const rowsWithPriority = originalOrder.map((row) => {
      if (row.priority == null) {
        const wd = getWorkingDays(row.orderPlacedDate, moment());
        if (row.documentType === "AO") {
          row.priority = 1;
        } else {
          if (wd > 9) row.priority = 1;
          else if (wd >= 5) row.priority = 2;
          else row.priority = 3;
        }
      }

      if (!row.remarks2) row.remarks2 = "";

      return row;
    });

    setCurrentOrder(rowsWithPriority);
  }, [originalOrder]);

  const handleDistributePriority = () => {
    if (!gridRef.current) return;

    const selectedNodes = gridRef.current.api.getSelectedNodes();
    if (selectedNodes.length === 0) return;

    selectedNodes.forEach((node) => {
      node.data.priority = Number(selectedPriority);
    });

    gridRef.current.api.applyTransaction({
      update: selectedNodes.map((n) => n.data),
    });
  };
  const handleAddRemarks = () => {
    if (!gridRef.current) return;

    const selectedNodes = gridRef.current.api.getSelectedNodes();
    if (selectedNodes.length === 0) return;

    selectedNodes.forEach((node) => {
      const oldValue = node.data.additionalRemarks || "";
      const newValue = oldValue ? `${oldValue}, ${remarksText}` : remarksText;

      node.setDataValue("remarks2", newValue);
    });

    setRemarksText("");
  };
  var filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      var dateAsString = cellValue;
      const date = new Date(dateAsString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;
      if (formattedDate == null) return -1;
      var dateParts = formattedDate.split("/");
      var cellDate = new Date(
        Number(dateParts[2]),
        Number(dateParts[1]) - 1,
        Number(dateParts[0]),
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    maxValidYear: new Date().getFullYear(),
  };
  const onSelectionChanged = (params) => {
    const rows = params.api.getSelectedRows();
    setSelectedRows(rows);
  };
  const getWorkingDays = (startDate, endDate) => {
    if (!startDate) return null;
    const start = moment(startDate).startOf("day");
    const end = moment(endDate).startOf("day");
    if (end.isBefore(start)) return 0;

    let cur = start.clone();
    let count = 0;

    cur.add(1, "day");

    while (cur.isSameOrBefore(end, "day")) {
      const day = cur.day();
      if (day !== 0 && day !== 6) count++;
      cur.add(1, "day");
    }

    return count;
  };
  const onGridReady = (params) => {
    // setTimeout(() => {
    //   params.columnApi.autoSizeAllColumns();
    // }, 100);
  };
  const handleSendReport = async () => {
    if (!gridRef.current) return;

    const allRows = [];

    gridRef.current.api.forEachNode((node) => {
      allRows.push(node.data);
    });

    const payload = allRows.map((row) => ({
      orderId: row.id,
      priority: row.priority,
      remarks2: row.remarks2 ?? "",
    }));

    try {
      const response = await OAuthService.addData(
        baseUrl + "/api/pending-ab-report",
        payload,
      );
      handleCloseReportSummery();
      toast.success("Pending AB Report Generated!");
    } catch (error) {
      handleCloseReportSummery();
      toast.error(error?.response?.data?.errorMessage || error.message);
    }
  };
  const columnDefs = [
    {
      headerName: "Sno.",
      maxWidth: 60,
      editable: false,
      filter: false,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      cellRenderer: (params) => {
        return params.node.rowIndex + 1;
      },
    },

    {
      headerName: "Customer Code & Country",
      valueGetter: (params) => {
        const commission = params.data?.commissionName || "";
        const country = params.data?.country || "";
        const customerCode = commission.substring(0, 2).toUpperCase();
        return `${customerCode} - ${country}`;
      },
      minWidth: 100,
      filter: "agMultiColumnFilter",
    },

    {
      headerName: "Account No",
      field: "accountNo",
      filter: "agMultiColumnFilter",
    },

    {
      field: "abNumber",
      headerName: "AB Number",
      enableRowGroup: true,
      filter: "agMultiColumnFilter",
    },

    {
      field: "commissionName",
      headerName: "Commission Name",
      enableRowGroup: true,
      minWidth: 250,
      filter: "agMultiColumnFilter",
    },

    {
      field: "orderPlacedDate",
      enableRowGroup: true,
      headerName: "Order Placed",
      cellRenderer: handleDateFormat,
      sort: "desc",
      filter: "agDateColumnFilter",
      filterParams,
    },

    {
      headerName: "Due (Days)",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        if (!params.data || !params.data.orderPlacedDate) return null;
        const orderPlacedDate = moment(params.data.orderPlacedDate);
        const currentDate = moment();
        return currentDate.diff(orderPlacedDate, "days");
      },
    },

    {
      field: "orderCategory",
      headerName: "Category",
      enableRowGroup: true,
      filter: "agMultiColumnFilter",
    },

    {
      headerName: "Due (Working Days)",
      filter: "agNumberColumnFilter",
      valueGetter: (params) => {
        const orderPlaced = params.data?.orderPlacedDate;
        if (!orderPlaced) return null;
        return getWorkingDays(orderPlaced, moment());
      },
    },

    {
      headerName: "Remarks",
      valueGetter: (params) => {
        const wd = getWorkingDays(params.data?.orderPlacedDate, moment());
        if (wd == null) return "";
        if (wd < 5) return "LESS THAN 5 DAYS";
        if (wd >= 5 && wd <= 9) return "DELAYED 5 DAYS & MORE";
        return "DELAYED 10 DAYS & MORE";
      },
      cellStyle: (params) => {
        const wd = getWorkingDays(params.data?.orderPlacedDate, moment());
        if (wd >= 5 && wd <= 9) {
          return { color: "orange", fontWeight: "bold" };
        }
        if (wd >= 10) {
          return { color: "red", fontWeight: "bold" };
        }
        return {};
      },
      filter: "agMultiColumnFilter",
    },
    {
      headerName: "Priority",
      field: "priority",
      cellStyle: { fontWeight: "bold" },
      filter: "agMultiColumnFilter",
    },
    {
      headerName: "ADD/RPL",
      field: "documentType",
      filter: "agMultiColumnFilter",
      valueGetter: (params) => {
        return params.data?.documentType === "AO" ? "ADD/RPL" : "";
      },
    },
    {
      headerName: "Additional Remarks",
      field: "remarks2",
      filter: "agMultiColumnFilter",
    },
  ];
  const defaultColDef = {
    filter: true,
    floatingFilter: true,
    resizable: true,
    sortable: true,
  };
  const handleDownloadExcel = () => {
    if (!currentOrder?.length) return;

    const headers = [
      "Sl. No.",
      "Customer",
      "Account Number",
      "AB Number",
      "Commission Name",
      "Order Placed Date",
      "Due Days (Including weekends)",
      "Order Category",
      "Due days (Working days)",
      "Remarks",
      "Priority",
      "ADD / RPL",
      "Remarks 2",
    ];

    const rows = currentOrder.map((row, index) => {
      const orderPlaced = row.orderPlacedDate
        ? moment(row.orderPlacedDate)
        : null;

      const dueCalendar = orderPlaced ? moment().diff(orderPlaced, "days") : "";

      const dueWorking = orderPlaced
        ? getWorkingDays(orderPlaced, moment())
        : "";

      let remarks = "";
      if (dueWorking < 5) remarks = "LESS THAN 5 DAYS";
      else if (dueWorking >= 5 && dueWorking <= 9)
        remarks = "DELAYED 5 DAYS & MORE";
      else if (dueWorking >= 10) remarks = "DELAYED 10 DAYS & MORE";

      const customerCode =
        row.commissionName?.substring(0, 2).toUpperCase() || "";

      return {
        "Sl. No.": index + 1,
        Customer: `${customerCode} - ${row.country || ""}`,
        "Account Number": row.accountNo || "",
        "AB Number": row.abNumber || "",
        "Commission Name": row.commissionName || "",
        "Order Placed Date": orderPlaced
          ? orderPlaced.format("DD-MM-YYYY")
          : "",
        "Due Days (Including weekends)": dueCalendar,
        "Order Category": row.orderCategory || "",
        "Due days (Working days)": dueWorking,
        Remarks: remarks,
        Priority: row.priority ? `Priority-${row.priority}` : "",
        "ADD / RPL": row.documentType === "AO" ? "ADD/RPL" : "",
        "Remarks 2": row.remarks2 || "",
      };
    });

    const ws = XLSX.utils.json_to_sheet(rows, {
      header: headers,
      origin: "B3",
    });

    ws["B1"] = {
      v: "Pending ABs Report",
      s: {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: "center", vertical: "center" },
      },
    };

    ws["!merges"] = [
      {
        s: { r: 0, c: 1 },
        e: { r: 0, c: headers.length },
      },
    ];

    headers.forEach((_, colIdx) => {
      const cell = XLSX.utils.encode_cell({
        r: 2,
        c: colIdx + 1,
      });

      ws[cell].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "C6EFCE" } },
        alignment: {
          horizontal: "center",
          vertical: "center",
          wrapText: true,
        },
        border: {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        },
      };
    });

    const dueDayCols = [
      headers.indexOf("Due Days (Including weekends)") + 1,
      headers.indexOf("Due days (Working days)") + 1,
    ];

    const remarksColIndex = headers.indexOf("Remarks") + 1;

    for (let r = 3; r < rows.length + 3; r++) {
      for (let c = 1; c <= headers.length; c++) {
        const cellRef = XLSX.utils.encode_cell({ r, c });
        if (!ws[cellRef]) continue;

        const cellValue = ws[cellRef].v;

        let fontStyle = {};
        if (c === remarksColIndex) {
          if (cellValue === "DELAYED 5 DAYS & MORE") {
            fontStyle = { color: { rgb: "FFA500" }, bold: true };
          }
          if (cellValue === "DELAYED 10 DAYS & MORE") {
            fontStyle = { color: { rgb: "FF0000" }, bold: true };
          }
        }

        ws[cellRef].s = {
          font: fontStyle,
          alignment: {
            horizontal: dueDayCols.includes(c) ? "left" : "center",
            vertical: "center",
          },
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    }

    const colWidths = headers.map((h, i) => {
      const maxLen = Math.max(
        h.length,
        ...rows.map((r) => String(Object.values(r)[i] ?? "").length),
      );
      return { wch: maxLen + 4 };
    });

    ws["!cols"] = [{ wch: 4 }, ...colWidths];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Pending ABs");

    const buffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      "Pending_ABs_Report.xlsx",
    );
  };
  const handleCloseReportSummery = () => {
    handleClose();
    setSelectedPriority("");
    setRemarksText("");
  };
  return (
    <>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        fullScreen={isMobile}
        onClose={handleCloseReportSummery}
      >
        <DialogTitle
          component="div"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            px: { xs: 2, md: 3 },
          }}
        >
          <Typography
            variant="h6"
            component="span"
            sx={{ fontSize: { xs: 16, md: 20 } }}
          >
            Pending ABs Report
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Tooltip title="Download Pending ABs Report">
              <Button
                variant="contained"
                size="small"
                sx={{
                  minWidth: "auto",
                  backgroundColor: theme.palette.secondary.main,
                  color: theme.palette.secondary.contrastText,
                }}
                onClick={handleDownloadExcel}
              >
                <FuseSvgIcon size={18}>heroicons-solid:save</FuseSvgIcon>
              </Button>
            </Tooltip>
            <Button onClick={handleCloseReportSummery} sx={{ minWidth: 40 }}>
              <FuseSvgIcon sx={{ color: theme.palette.secondary.main }}>
                heroicons-solid:x
              </FuseSvgIcon>
            </Button>
          </Box>
        </DialogTitle>

        <DialogContent classes={{ root: "p-16 sm:p-24" }} dividers>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 2, md: 3 },
              alignItems: { xs: "stretch", md: "center" },
              mb: 2,
              p: { xs: 0, md: 2 },
              borderRadius: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: { xs: "wrap", sm: "nowrap" },
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{ minWidth: { xs: 100, md: "auto" } }}
              >
                Priority:
              </Typography>

              <Select
                size="small"
                value={selectedPriority}
                onChange={(e) => setSelectedPriority(e.target.value)}
                sx={{ width: { xs: 90, md: 120 } }}
                disabled={selectedRows.length === 0}
              >
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
              </Select>

              <Button
                variant="contained"
                color="secondary"
                onClick={handleDistributePriority}
                disabled={selectedRows.length === 0 || !selectedPriority}
                sx={{ flex: { xs: 1, md: "0 0 auto" } }}
              >
                Distribute
              </Button>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "stretch", md: "center" },
                flexDirection: { xs: "column", sm: "row" },
                gap: 1.5,
              }}
            >
              <Typography
                variant="subtitle2"
                sx={{ minWidth: { xs: 100, md: "auto" } }}
              >
                Add Remarks:
              </Typography>

              <TextField
                size="small"
                value={remarksText}
                onChange={(e) => setRemarksText(e.target.value)}
                placeholder="Enter remarks"
                sx={{ width: { xs: "100%", md: 250 } }}
                disabled={selectedRows.length === 0}
              />

              <Button
                variant="contained"
                color="secondary"
                onClick={handleAddRemarks}
                disabled={selectedRows.length === 0 || !remarksText}
              >
                Add
              </Button>
            </Box>
          </Box>

          <Box sx={{ overflowX: "auto", width: "100%" }}>
            <div
              className="ag-theme-alpine-dark grid text-left"
              style={{ minWidth: isMobile ? 900 : "auto" ,height:"100%"}}
            >
              <AgGridReact
                ref={gridRef}
                rowData={currentOrder}
                onGridReady={onGridReady}
                columnDefs={columnDefs}
                onSelectionChanged={onSelectionChanged}
                headerHeight={28}
                rowHeight={22}
                domLayout={"autoHeight"}
                defaultColDef={defaultColDef}
                rowSelection="multiple"
                cellSelection={true}
                suppressRowClickSelection={true}
              />
            </div>
          </Box>

          <Box sx={{ mt: 2.5 }}>
            <Button
              fullWidth={isMobile}
              sx={{
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.secondary.contrastText,
                "&:hover": { backgroundColor: theme.palette.secondary.dark },
              }}
              variant="contained"
              onClick={handleSendReport}
            >
              Send Reports
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
}
